import { render, staticRenderFns } from "./NCFDetail.vue?vue&type=template&id=4231f843&scoped=true&"
import script from "./NCFDetail.vue?vue&type=script&lang=js&"
export * from "./NCFDetail.vue?vue&type=script&lang=js&"
import style0 from "./NCFDetail.vue?vue&type=style&index=0&id=4231f843&prod&scoped=true&lang=css&"
import style1 from "./NCFDetail.vue?vue&type=style&index=1&id=4231f843&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4231f843",
  null
  
)

export default component.exports